import { useEffect, useState } from "react"
import { createFileRoute, Link } from "@tanstack/react-router"

interface VerifySearch {
  token?: string
}

export const Route = createFileRoute("/verify-email")({
  validateSearch: (s: Record<string, unknown>): VerifySearch => ({
    token: typeof s.token === "string" ? s.token : undefined,
  }),
  component: VerifyEmailPage,
})

function VerifyEmailPage() {
  const { token } = Route.useSearch()
  const [state, setState] = useState<"pending" | "ok" | "error">("pending")
  const [msg, setMsg] = useState("")

  useEffect(() => {
    if (!token) { setState("error"); setMsg("Missing token. Open the link from your email."); return }
    fetch(`/api/auth/verify-email?token=${encodeURIComponent(token)}`).then((r) => {
      if (r.status === 204 || r.ok) {
        setState("ok")
      } else {
        setState("error")
        setMsg(`Verification failed (${r.status}). The link may have expired.`)
      }
    }).catch(() => {
      setState("error")
      setMsg("Verification failed. Network error.")
    })
  }, [token])

  return (
    <div className="min-h-screen grid place-items-center px-4 bg-background text-center">
      <div className="w-full max-w-sm space-y-3">
        {state === "pending" && (
          <p className="text-sm text-muted-foreground">Verifying your email…</p>
        )}
        {state === "ok" && (
          <>
            <h1 className="text-xl font-semibold tracking-tight">Email verified</h1>
            <p className="text-sm text-muted-foreground">You can now sign in.</p>
            <Link to="/login" className="text-sm underline">Continue to sign in</Link>
          </>
        )}
        {state === "error" && (
          <>
            <h1 className="text-xl font-semibold tracking-tight">Verification failed</h1>
            <p className="text-sm text-muted-foreground">{msg}</p>
            <Link to="/login" className="text-sm underline">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  )
}
